module.exports = __webpack_public_path__ + "static/media/error.125293b0.svg";